<template>
  <b-modal
    id="issue-order-nfse-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
    @shown="shown"
    @hidden="hidden"
  >
    <div class="text-center">
      <h2 class="highlighted-color1">
        <span>{{ $t('issue_invoice') }}</span>
      </h2>
    </div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="text-center mt-3">
      <template v-if="order">
        <p>{{ $t('want_to_issue_the_invoice.0') }} <strong>{{ order.amount/ 100 | formatMoney }}</strong> {{ $t('want_to_issue_the_invoice.1') }} <strong>{{ order.advertiser.name }}</strong>?</p>
        <Button
          type="button"
          class="btn-color10 mt-4"
          @click="submit"
          :loading="loader"
        >
          {{ $t('issue_invoice') }}
        </Button>
      </template>
    </div>
  </b-modal>
</template>

<script>

import NotificationService from '@/modules/notifications/services/notifications-service'
import OrdersService from '@/modules/orders/services/orders-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'IssueOrderNFSeModal',
  props: ['order'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false
    }
  },
  methods: {
    /**
     * On modal hidden
     */
    hidden () {
    },
    /**
     * On modal shown
     */
    shown () {
    },
    /**
     * Get order
     */
    async submit () {
      this.loader = true
      try {
        await OrdersService.issueNFSe(this.order.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('invoice_issued_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('order-nfse-issued', this.order)
        this.$bvModal.hide('issue-order-nfse-modal')
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
